import { Component, TemplateRef } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ResourceService } from 'src/app/services/common/resource.service';
import { UserService } from 'src/app/services/user.service';
import { HttpClient } from '@angular/common/http';
import { UtilityService } from 'src/app/services/utility.service';
declare const gtag: Function;
import { SafeResourceUrl } from '@angular/platform-browser'; // (already imported DomSanitizer)
import { Subscription } from 'rxjs';
import { ThemeService, Theme } from 'src/app/services/theme.service';
import { UserInfoService } from 'src/app/services/user-info.service';


type SocialLinks = {
  website?: string;
  instagram?: string;
  facebook?: string;
  twitter?: string;
  tiktok?: string;
  pinterest?: string;
  linkedin?: string;
  youtube?: string;
  buyonline?: string;
  amazon?: string;
  flipkart?: string;

};

type VariantHeader = {
  name: string;
  id: string;
};

@Component({
  selector: 'app-featured-product-details',
  templateUrl: './featured-product-details.component.html',
  styleUrls: ['./featured-product-details.component.scss']
})
export class FeaturedProductDetailsComponent {
  youtubeEmbedUrl?: SafeResourceUrl;

  selectedAttributes: Record<string, string> = {};

  openedAttributeIds = new Set<string>();

  // openedAttributeIds = new Set<number>();

  // openedAttributeId: number | null = null;

  showAllVariants = false;

  activeAttribute: any = null;
  // isVariantDropdownOpen = false;

  selectedCells: string[] = [];

  private itemBound = false;

  isTableOpen = false;

  dealBackgroundColor = 'white';
  private subs = new Subscription();
  links: any
  userID: any = "";
  user: any = null;
  waNumber = '';
  waMessage = '';
  wpImage = "assets/img/wpButton.jpg";
  whatsappURL: string = 'https://wa.me/';
  vcardText!: string;
  VPA_REGEX = /^[\w.\-]{2,256}@[A-Za-z]{2,64}$/;
  upi_id!: string;
  upiImg = "assets/img/bhim.png";
  // showPriceOnOffer: any = false;
  showPriceOnOffer = false;

  get storeId(): string | null {
    return this.findParam(this.router.routerState.snapshot.root, 'storeId');
  }

  social: SocialLinks = {};
  productImagesOptions = {
    loop: true,
    items: 2,
    dots: true,
    nav: true,
    autoplay: true,
    margin: 0,
    stagePadding: 0,
    autoWidth: false,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    navText: ['<', '>'],
    responsive: {
      0: {
        items: 2 // 3 item on small screens
      },
      768: {
        items: 2 // 2 items on tablets
      },
      1024: {
        items: 2 // 3 items on desktop
      }
    }
  };


  ID: any;
  filteredDetail: any = [];
  item: any;
  safeDescription!: SafeHtml;
  baseurl: string = '';
  // smsUrl :any;
  resource: any = {};
  popup!: boolean;
  organizationId!: string;
  slug!: string;
  itemVariantAtrributePrice: any;
  // headers = [];
  headers: VariantHeader[] = [];
  tableRows: any;
  company_logo: any
  storeEmail: string = '';
  constructor(
    private meta: Meta,
    private title: Title,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private resourceService: ResourceService,
    private userService: UserService,
    private _httpClient: HttpClient,
    private utilityService: UtilityService,
    private themeService: ThemeService,
    private UserInfoService: UserInfoService,


  ) {
    this.route.data.subscribe(({ data }) => {
      console.log("{ data }", { data })
      if (data.data) {
        this.organizationId = data.data;
        this.slug = route.snapshot.paramMap.get('slug')!;
      }
    })
  }

  ngOnInit() {
    this.loadResoruce();
    this.resourceService.languageSubject.subscribe(r => this.resource = r);
    this.baseurl = environment.shareUrl;

    this.ID = this.route.snapshot.paramMap.get('id') || '';
    console.log("this.ID", this.ID)

    this.utilityService.detail(this.ID).subscribe({
      next: (res) => {
        console.log("res----------", res)
        const data = res?.data;
        // this.showPriceOnOffer = true;
        console.log("this.showPriceOnOffer", this.showPriceOnOffer)
        if (res.success && data) {

          this.showPriceOnOffer =
            data.showPriceOnOffer !== undefined
              ? !!data.showPriceOnOffer
              : true; 
          // this.showPriceOnOffer = !!data.showPriceOnOffer;
          console.log('showPriceOnOffer:', this.showPriceOnOffer);

          var filterModel = {
            pageSize: 100,
            pageIndex: 1,
            productId: this.ID
          }

          // this.headers = res.data.attributes.map(attr => {
          //   return {name: attr.name, id: attr.id}
          // });
          // this.headers.push({name: 'price', id: 'price'});

          this.headers = res.data.attributes.map((attr: any) => ({
            name: attr.name,
            id: String(attr.id)   // ✅ FORCE STRING
          }));

          if (this.showPriceOnOffer) {
            this.headers.push({ name: 'Price', id: 'price' });
          }
          console.log('Headers:', this.headers);


          if (this.storeId) {

            this.utilityService.catalogueVariantList(this.organizationId, this.storeId, this.ID).subscribe({
              next: (result) => {
                let itemVariantAtrributePrice = result.data.variants;
                this.tableRows = itemVariantAtrributePrice.map((item: any) => {
                  const attrVal = res.data.attributes.reduce(
                    (
                      acc: Record<string, any>,
                      attr: { id: string | number }
                    ) => {
                      acc[String(attr.id)] = item.attributeValues?.[attr.id];
                      return acc;
                    },
                    {} as Record<string, any>
                  );

                  return {
                    ...attrVal,
                    ...(this.showPriceOnOffer ? { price: item.price } : {})
                  };
                });
              },
              error: (error) => {
                console.log(error)
              }
            }
            )
          } else {

            this.utilityService.productVariantList(filterModel).subscribe({
              next: (result) => {
                let itemVariantAtrributePrice = result.data
                this.tableRows = itemVariantAtrributePrice.map((item: any) => {
                  const attrVal = res.data.attributes.reduce(
                    (
                      acc: Record<string, any>,
                      attr: { id: string | number }
                    ) => {
                      acc[String(attr.id)] = item.attributeValues?.[attr.id];
                      return acc;
                    },
                    {} as Record<string, any>
                  );

                  return {
                    ...attrVal,
                    ...(this.showPriceOnOffer ? { price: item.price } : {})
                  };
                });

              },
              error: (error) => {
                console.log(error)
              }
            }
            )
          }
        }
      },
      error: (error) => {
        console.log(error)
      }

    })


    const qp = this.route.snapshot.queryParams;
    const ownerId = qp?.organizationId || qp?.storeId || this.organizationId || null;
    this.utilityService.getFeaturedProductById(this.ID).subscribe({
      next: (res: any) => {
        const data = res?.data || res;

        if (data && data._id) {
          this.bindItem(data);
        } else if (ownerId) {
          this.loadFromOwner(ownerId);
        }
      },
      error: () => {
        if (ownerId) this.loadFromOwner(ownerId);
      }
    });
    this.subs.add(
      this.themeService.theme$.subscribe((t: Theme) => {
        this.dealBackgroundColor = (t === 'light') ? 'white' : 'black';
      })
    );

    const params = this.route.snapshot.queryParams;

    if (params['wishlist']) {

      //const data = JSON.parse(atob(params['wishlist']));
      if (params['storeEmail']) { this.storeEmail = params['storeEmail']; }
      const data = JSON.parse(decodeURIComponent(atob(params['wishlist'])));
      console.log(`data from redirect url: ${JSON.stringify(data)}`);
      this.onAddToCart(data);
    }
  }

  ngAfterViewInit() {
    this.initMagneticEffect();
  }

  initMagneticEffect() {
    if (window.matchMedia('(hover: none)').matches) return;

    const maxDistance = 120;
    const maxTranslate = 20;

    document.querySelectorAll(
      '.variant-attr-pill, .variant-value-pill'
    ).forEach((el: HTMLElement) => {

      let lastX = 0;
      let lastY = 0;

      el.addEventListener('mousemove', (e: MouseEvent) => {
        // 🧠 disable magnet if dropdown open
        if (this.openedAttributeIds?.size) return;

        const rect = el.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;

        const dx = e.clientX - cx;
        const dy = e.clientY - cy;

        const dist = Math.sqrt(dx * dx + dy * dy);
        const proximity = Math.max(0, 1 - dist / maxDistance);

        const strength = proximity * proximity;

        const tx = dx * strength * 0.15;
        const ty = dy * strength * 0.15;

        lastX = tx;
        lastY = ty;

        // 🎨 dynamic glow
        const glowAlpha = 0.15 + proximity * 0.45;
        el.style.boxShadow = `
        0 0 ${8 + proximity * 18}px rgba(0,0,0,${glowAlpha})
      `;

        el.style.transform = `
        translate(${tx}px, ${ty}px)
        scale(${1 + proximity * 0.06})
      `;
      });

      // 🧲 repulsion on fast exit
      el.addEventListener('mouseleave', () => {
        el.style.transition = 'transform 0.25s cubic-bezier(.25,1.5,.5,1)';
        el.style.transform = `
        translate(${-lastX * 1.4}px, ${-lastY * 1.4}px)
        scale(1)
      `;
        el.style.boxShadow = '';

        setTimeout(() => {
          el.style.transition = '';
          el.style.transform = '';
        }, 160);
      });
    });
  }


  private findParam(route: ActivatedRouteSnapshot, key: string): string | null {
    // check current level
    const v = route.paramMap.get(key);
    if (v) return v;

    // go deeper
    for (const child of route.children) {
      const found = this.findParam(child, key);
      if (found) return found;
    }
    return null;
  }

  private loadFromOwner(ownerId: string) {
    this.utilityService.getProductDetails(ownerId).subscribe({
      next: (res: any) => {
        const list = res?.data || [];
        const found = list.find((x: any) => x?._id === this.ID);
        if (found) this.bindItem(found);
      },
      error: (e) => console.error(e)
    });
  }

  private bindItem(found: any) {
    if (this.itemBound) return;
    this.itemBound = true;

    this.item = found;
    this.filteredDetail = [found];

    if (found?.featureVideoLink && this.isYouTube(found.featureVideoLink)) {
      const embed = this.getYouTubeEmbed(found.featureVideoLink);
      if (this.youtubeEmbedUrl !== embed) {
        this.youtubeEmbedUrl = embed;
      }
    } else {
      this.youtubeEmbedUrl = undefined;
    }

    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(
      found?.feature_richtext_description || ''
    );

    const userId =
      found?.userId || found?.user || found?.ownerId || found?.createdBy || null;

    if (userId) {
      this.loadUserDetail2(userId, found);
    }
  }

  //   private bindItem(found: any) {
  //   if (this.itemBound) return;
  //   this.itemBound = true;
  //   this.youtubeEmbedUrl = undefined; 

  //   if (found?.featureVideoLink && this.isYouTube(found.featureVideoLink)) {
  //     this.youtubeEmbedUrl = this.getYouTubeEmbed(found.featureVideoLink);
  //   }

  //   this.item = found;
  //   this.filteredDetail = [found];

  // if (found?.featureVideoLink && this.isYouTube(found.featureVideoLink)) { 
  //   this.youtubeEmbedUrl = this.getYouTubeEmbed(found.featureVideoLink);
  // } else {
  //   this.youtubeEmbedUrl = undefined;
  // }

  //     this.safeDescription = null!;

  //     this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(
  //       found?.feature_richtext_description
  //         ? found.feature_richtext_description.replace(
  //           '<p>',
  //           '<p><span style="font-weight:600; color:#000000">Description:</span> '
  //         )
  //         : ''
  //     );

  //     const userId =
  //       found?.userId ||
  //       found?.user ||
  //       found?.ownerId ||
  //       found?.createdBy ||
  //       null;

  //     if (userId) {
  //       this.loadUserDetail2(userId, found);
  //     }
  //   }


  // private bindItem(found: any) {
  //   this.sendGAData(found);
  //   this.item = found;
  //   this.filteredDetail = [found];

  //   this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(
  //     this.item?.feature_richtext_description || ''
  //   );

  //   // this.getWhatsAppUrl(this.item);
  //   // this.getSmsUrl(this.item);

  //   const userId =
  //     this.item?.userId ||
  //     this.item?.user ||
  //     this.item?.ownerId ||
  //     this.item?.createdBy || null;

  //   // if (userId) this.loadUserDetail(userId, this.item);
  //   if (userId) this.loadUserDetail2(userId, this.item);
  // }

  private sendGAData(item) {
    const route = this.getDeepestChild(this.route);
    const routeParams = { ...route.snapshot.params };
    const queryParams = route.snapshot.queryParams ?? {};
    const fragment = route.snapshot.fragment ?? null;
    const urlTree = this.router.createUrlTree(
      [this.router.url.split('?')[0]],
      { queryParams }
    );
    const page_path = this.router.serializeUrl(urlTree); // includes query if present
    const page_location = window.location.href;
    gtag('event', 'page_view', {
      page_title: document.title,
      page_path,
      page_location,
      org_id: routeParams['slug'] || queryParams['organizationId'],
      store_id: routeParams['storeId'] || queryParams['storeId'],
      product_id: this.ID,
      product_name: item.name,
      social_media_source: queryParams['source']
    });
  }

  private getDeepestChild(ar: ActivatedRoute): ActivatedRoute {
    let child = ar;
    while (child.firstChild) child = child.firstChild;
    return child;
  }

  getFilteredFeaturedList(featuredList: any[], id: string) {
    return featuredList
      .filter(item => item._id === id)
      .map(item => ({
        ...item,
        safeDescription: this.sanitizer.bypassSecurityTrustHtml(item.feature_richtext_description || '')
      }));
  }

  openShareDialog(templateRef: TemplateRef<any>, event: MouseEvent) {
    event?.preventDefault();

    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const padding = 12;

    const desiredWidth = 178;
    const widthPx = Math.min(desiredWidth, vw - padding * 2);

    if (vw <= 480) {
      this.dialog.open(templateRef, {
        width: '100vw',
        maxWidth: '100vw',
        panelClass: ['share-dialog', 'share-dialog--bottom'],
        hasBackdrop: true,
        autoFocus: false,
        restoreFocus: false,
        position: { left: '0', bottom: '0' }
      });
      return;
    }


    const x = event.clientX;
    const y = event.clientY;
    const estimatedHeight = 80;

    const left = Math.min(vw - widthPx - padding, x + 12);
    const top = Math.min(vh - estimatedHeight - padding, Math.max(padding, y - estimatedHeight / 25));

    this.dialog.open(templateRef, {
      width: `${widthPx}px`,
      maxWidth: '95vw',
      panelClass: 'share-dialog',
      hasBackdrop: true,
      autoFocus: false,
      restoreFocus: false,
      position: { left: `${left}px`, top: `${top}px` },
    });
  }


  shareOnFacebook(item: any) {
    const message =
      `${item.feature_contact_method || ''}\n\n` +
      `${item.feature_contact_name || ''}\n` +
      `${item.feature_contact_designation || ''}\n` +
      `${window.location.href}`;

    let shareUrl: string;
    shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }

  shareOnTwitter(item: any): void {
    let shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;
    const text = `${item.feature_contact_method || ''} ${item.feature_contact_name || ''} ${item.feature_contact_designation || ''}`;
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(text)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }


  shareOnLinkedIn(item: any): void {
    let shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      '_blank',
      'noopener,noreferrer'
    );
  }

  shareOnInstagram(item: any): void {
    const shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;

    navigator.clipboard.writeText(shareUrl).then(() => {
      const snackRef = this.snackBar.open(
        "✅ Link copied! Paste it in your Instagram post, story, or bio.",
        "OK",
        { duration: 2000 }
      );

      setTimeout(() => {
        snackRef.dismiss();

        const ua = navigator.userAgent;

        if (/Android/i.test(ua)) {
          window.location.href =
            "intent://instagram.com/#Intent;package=com.instagram.android;scheme=https;end";
        } else if (/iPhone|iPad|iPod/i.test(ua)) {
          window.location.href = "instagram://app";

          setTimeout(() => {
            window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
          }, 1500);
        } else {
          window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
        }
      }, 500);
    }).catch((err: any) => {
      console.error("Clipboard copy failed:", err);
      this.snackBar.open("❌ Could not copy link. Please copy manually.", "OK", { duration: 2000 });
    });
  }

  onCopyClick(event: MouseEvent, item?: any) {
    event.preventDefault();
    this.copyLink(item);
  }
  fallbackCopy(text: string, ctx: any) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      ctx.snackBar.open('✅ Link copied to clipboard!', 'OK', { duration: 2000 });
    } catch (e) {
      console.warn('execCommand fallback failed', e);
      ctx.snackBar.open('❌ Please copy the link manually: ' + text, 'OK', { duration: 4000 });
    }
    document.body.removeChild(ta);
  }

  copyLink(item?: any) {
    const base = (this.baseurl || '').replace(/\/$/, '');
    const path = this.router.url || '';
    const urlToCopy = `${base}#${path}`;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(urlToCopy)
        .then(() => this.snackBar.open('Link copied!', 'OK', { duration: 2000 }))
        .catch(() => this.fallbackCopy(urlToCopy, this));
      return;
    }
    this.fallbackCopy(urlToCopy, this);
  }

  // copyLink(item: any) {
  //   if (!item?._id) {
  //     this.snackBar.open('❌ Invalid product — no ID found.', 'OK', { duration: 2000 });
  //     return;
  //   }

  //   const shareUrl = `${this.baseurl}#/deal/featured-product-details/${item._id}`;

  //   navigator.clipboard?.writeText(shareUrl).then(() => {
  //     const snackRef = this.snackBar.open('✅ Link copied to clipboard!', 'OK', { duration: 2000 });

  //     snackRef.afterDismissed().subscribe(() => {
  //     });
  //   }).catch(() => {
  //     const textArea = document.createElement('textarea');
  //     textArea.value = shareUrl;
  //     textArea.style.position = 'fixed';
  //     textArea.style.left = '-9999px';
  //     document.body.appendChild(textArea);
  //     textArea.select();

  //     try {
  //       document.execCommand('copy');
  //       const snackRef = this.snackBar.open('✅ Link copied to clipboard!', 'OK', { duration: 2000 });
  //       snackRef.afterDismissed().subscribe(() => { });
  //     } catch {
  //       this.snackBar.open('❌ Please copy the link manually: ' + shareUrl, 'OK', { duration: 4000 });
  //     }
  //     document.body.removeChild(textArea);
  //   });
  // }

  getWhatsAppUrl(item: any) {
    const waMessage =
      `${item.feature_contact_method || ''}\n\n` +
      `${item.feature_contact_name || ''}\n` +
      `${item.feature_contact_designation || ''}\n` +
      `${window.location.href}`;

    let phone = String(item?.mobile ?? '').replace(/\D/g, '');
    const cc = String(item?.countryCode ?? '').replace(/\D/g, '');

    if (cc && !phone.startsWith(cc)) phone = cc + phone;

    this.whatsappURL = `https://wa.me/${phone}?text=${encodeURIComponent(waMessage)}`;
  }

  areAllAttributesSelected(): boolean {
    const baseSelected = this.variantHeaders.every(
      h => this.selectedAttributes[h.id]
    );

    if (!baseSelected) return false;

    if (this.showPriceOnOffer) {
      return (
        this.selectedAttributes['price'] !== undefined ||
        this.tableRows?.some(r =>
          Object.entries(this.selectedAttributes).every(
            ([k, v]) => String(r[k]) === String(v)
          )
        )
      );
    }

    return true;
  }


  onAddToCart(row: any) {
    //alert('hi');
    //check if selected item is there then no need to add in row

    const selected = Object.entries(this.selectedAttributes).map(([key, value]) => ({
      attribute: key,
      value: value
    }));

    //   console.log(selected);
  
    if (!row.selectedItem) {
      row = {
        ...row,
        selectedItem: selected,
        ...(this.showPriceOnOffer
          ? { price: this.selectedAttributes['price'] }
          : {})
      };
    }
    console.log(JSON.stringify(row));

    // if there is no login then first login 
    let isLoggedIn = this.UserInfoService.getLoginFlag();
    if (!isLoggedIn) {

      let returnUrl = this.router.url;


      //const encodedWishlist = btoa(JSON.stringify(row));
      const encodedWishlist = btoa(encodeURIComponent(JSON.stringify(row)));
      returnUrl += `&wishlist=${encodedWishlist}&storeEmail=${this.storeEmail}`;
      console.log(`return URL: ${returnUrl}`);



      this.router.navigate(['/login'], {
        queryParams: {
          returnUrl: encodeURIComponent(returnUrl)
        }
      });


      return;
    }

    console.log(`data for the cart : ${JSON.stringify(this.generateMiniCartJson(row))}`);
    const data = this.generateMiniCartJson(row); 

    const miniCart = (window as any).MiniCart;

    if (miniCart && typeof miniCart.add === 'function') {
      miniCart.add(data); 
    } else {
      console.error('MiniCart is not available on window');
      this.snackBar.open(
        'Cart service unavailable. Please refresh and try again.',
        'OK',
        { duration: 3000 }
      );
      return;
    }
    this.selectedAttributes = {};
    //remove wishlist from url

    const params = { ...this.route.snapshot.queryParams };
    if (params['wishlist']) {
      delete params['wishlist'];

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params
      });
    }
  }


  getCurrencySymbol(): string {
    const data = localStorage.getItem('globalSearch');
    return data ? JSON.parse(data).currencySymbol : '$';
  }

  getCurrencyName(): string {
    const data = localStorage.getItem('globalSearch');
    return data ? JSON.parse(data).currencyName : 'USD';
  }

  generateMiniCartJson(item: any) {
    // const isProduct = !!item.price;
    const isProduct = !!(item._id || item.productId);
    const isCampaign = !!item.campaignName;

    // Extract product
    const product = isProduct
      ? item
      : item.productDetails?.[0] || {};

    // Build tax array (ALL slabs)
    const taxes = (product.taxPercentageSlab || []).map(tax => ({
      type: tax.taxName,
      rate: tax.percentage,
      inclusive: false
    }));

    // Campaign mapping
    const campaign = isCampaign
      ? {
        id: item.campaignId || item._id,
        name: item.campaignName,
        orgId: item.orgId || 'ORG123'
      }
      : null;

    return {
      id: product._id,
      name: product.name,
      // price: product.price || 0,
      ...(this.showPriceOnOffer
        ? { price: product.price || 0 }
        : {}),
      qty: 1,
      "currency_symbol": this.getCurrencySymbol(),
      "currency": this.getCurrencyName(),
      tax: taxes.length ? taxes : [
        { type: 'GST', rate: 0, inclusive: true }
      ],
      selectedItem: product.selectedItem || [],
      campaign,
      storeEmail: this.storeEmail || '',
      meta: {
        userPhone: item.userPhone || '9199999999999',
        storePhone: item.storePhone || '',
        hostId: item.hostId || 'onoffer',
        guest: item.guest ?? false,

      }
    };
  }
  // getSmsUrl(item: any) {
  //   const body =
  //     `${item.feature_contact_method || ''}\n\n` +
  //     `${item.feature_contact_name || ''}\n` +
  //     `${item.feature_contact_designation || ''}\n` +
  //     `${window.location.href}`;

  //   let phone = String(item?.mobile ?? '').replace(/\D/g, '');
  //   const cc   = String(item?.countryCode ?? '').replace(/\D/g, '');
  //   if (cc && !phone.startsWith(cc)) phone = cc + phone;

  //   this.smsUrl = `sms:${phone}?&body=${encodeURIComponent(body)}`;
  // }

  loadResoruce() {
    this.resourceService.loadResoruce().subscribe(
      response => {
        this.resource = response;
      });
  }

  getAllImages(item: any) {
    return [...(item.productImages || []), ...(item.featureOptionalImages || [])];
  }

  absoluteUrl(u?: string) {
    if (!u) return 'assets/img/no-image.png';
    return /^https?:\/\//i.test(u) ? u : `${this.baseurl.replace(/\/$/, '')}/${u.replace(/^\//, '')}`;
  }

  private toUrl(v?: string): string {
    const s = (v || '').trim();
    if (!s) return '';
    if (/^https?:\/\//i.test(s)) return s;
    return `https://${s}`;
  }

  private buildWhatsAppUrl(waNumber?: string, waMessage?: string, countryCode?: string): string {
    const digits = String(waNumber || '').replace(/\D/g, '');
    const cc = String(countryCode || '').replace(/\D/g, '');

    const phone = digits ? ((cc && !digits.startsWith(cc)) ? cc + digits : digits) : '';
    const text = encodeURIComponent(waMessage || '');

    return phone
      ? `https://wa.me/${phone}${text ? `?text=${text}` : ''}`
      : `https://wa.me/${text ? `?text=${text}` : ''}`;
  }

  buildWhatsAppInquiry(item: any, phone?: string, countryCode?: string): string {
    const productName = item?.name || 'this item';

    const message = `Hi, can you share more details about this "${productName}"?`;

    let digits = String(phone || '').replace(/\D/g, '');
    const cc = String(countryCode || '').replace(/\D/g, '');

    if (cc && !digits.startsWith(cc)) {
      digits = cc + digits;
    }

    return digits
      ? `https://wa.me/${digits}?text=${encodeURIComponent(message)}`
      : `https://wa.me/?text=${encodeURIComponent(message)}`;
  }




  private loadUserDetail(id: string, featuredItem?: any, links?: any) {
    this.userService.detail(id).subscribe({
      next: (res) => {
        let u = (res && res.data) ? res.data : res;


        for (let i = 0; i < links.length; i++) {
          u[links[i].mediaType] = links[i].mediaValue

        }
        this.storeEmail = res.data.email;
        this.whatsappURL = this.buildWhatsAppInquiry(
          featuredItem,
          u.waNumber,
          u.countryCode
        );

        this.waNumber = u.waNumber || '';
        this.waMessage = u.waMessage || '';

        const s: SocialLinks = {};
        const add = (key: keyof SocialLinks, val?: string) => {
          const url = this.toUrl(val);
          if (url) s[key] = url;
        };

        add('website', u.website);
        add('instagram', u.instagram);
        add('facebook', u.facebook);
        add('twitter', u.twitter);
        add('tiktok', u.tiktok);
        add('pinterest', u.pinterest);
        add('linkedin', u.linkedin || u.linkedinUrl);
        add('youtube', u.youtube);
        add('buyonline', u.o);
        add('amazon', u.amazon);
        add('flipkart', u.flipkart);

        this.buildVCard(u)
        this.social = s;
        this.upi_id = u.upi_id;
      },
      error: (e) => console.error(e)
    });
  }

  private loadUserDetail2(id: string, featuredItem?: any) {
    this.userService.links(id).subscribe({
      next: (res) => {
        this.links = (res && res.data) ? res.data : res;
        this.loadUserDetail(id, featuredItem, this.links)
      },
      error: (e) => console.error(e)
    });
  }


  private esc(s: string | undefined): string {
    return (s || '').replace(/,/g, '\\,').replace(/\n/g, '\\n');
  }

  private buildVCard(user: any) {
    console.log({ user });
    this.company_logo = user?.company_logo
    let type = 'JPEG'; // default

    if (user?.company_logo) {
      const ext = user.company_logo.split('.').pop()?.toLowerCase();
      if (ext === 'png') type = 'PNG';
      if (ext === 'jpg' || ext === 'jpeg') type = 'JPEG';
    }

    const lines = [
      'BEGIN:VCARD',
      'VERSION:4.0',
      'KIND:org',
      `N:${this.esc(user.lastName)};${this.esc(user.firstName)};;;`,
      `FN:${this.esc(`${user.firstName} ${user.lastName}`.trim())}`,

      user.company ? `ORG:${this.esc(user.company)}` : '',
      user.telephone ? `TEL;TYPE=CELL,VOICE:${user.telephone}` : '',
      user.email ? `EMAIL;TYPE=INTERNET:${user.email}` : '',
      user.website ? `URL:${this.esc(user.website)}` : '',

      user.company_logo
        ? `PHOTO;TYPE=${type};VALUE=URI:${this.esc(user.company_logo)}`
        : '',

      'END:VCARD'
    ].filter(Boolean);

    this.vcardText = lines.join('\r\n');
  }

  // private buildVCard(user: any) {
  //   console.log({ user });    
  //   const ext = user?.company_logo.split('.').pop()?.toLowerCase();
  //   let type = 'JPEG'; // default
  //   if (ext === 'png') type = 'PNG';
  //   if (ext === 'jpg' || ext === 'jpeg') type = 'JPEG';
  //   const lines = [
  //     'BEGIN:VCARD',
  //     'VERSION:4.0',
  //     'KIND:org',
  //     `N:${this.esc(user.lastName)};${this.esc(user.firstName)};;;`,
  //     `FN:${this.esc(`${user.firstName} ${user.lastName}`.trim())}`,
  //     '',
  //     user.company ? `ORG:${this.esc(user.company)}` : '',
  //     user.telephone ? `TEL;TYPE=CELL,VOICE:${user.telephone}` : '',
  //     user.email ? `EMAIL;TYPE=INTERNET:${user.email}` : '',
  //     user.website ? `URL:${this.esc(user.website)}` : '',
  //     '',
  //     '',
  //     user.company_logo ? `PHOTO;TYPE=${type};VALUE=URI:${this.esc(user.company_logo)}` : '',
  //     'END:VCARD'
  //   ].filter(Boolean);

  //   this.vcardText = lines.join('\r\n');
  // }

  downloadVcard(): void {
    const blob = new Blob([this.vcardText], { type: 'text/vcard;charset=utf-8' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    // Desktop: downloads; Mobile: usually opens Contacts “Add” UI
    a.download = `${('contact')}-${('card')}.vcf`;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.remove();
    }, 1000);
  }

  buildUpiUri(p: string): string {
    const params = new URLSearchParams();
    params.set('pa', p);
    params.set('cu', 'INR');
    return `upi://pay?${params.toString()}`;
  }

  /**
 * Tries to open a UPI app. Must be called from a user gesture (click/tap).
 * Returns a best-effort Promise (we can't truly detect success due to browser privacy).
 */
  openUpi(opts?: { fallbackUrl?: string }): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.VPA_REGEX.test(this.upi_id)) {
        reject(new Error('Invalid UPI ID (VPA).'));
        return;
      }

      const uri = this.buildUpiUri(this.upi_id);
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.includes('android');

      // Try the universal UPI URI first
      const timer = setTimeout(() => {
        // If nothing happened, try Android "intent://" as a second shot
        if (isAndroid) {
          const q = uri.replace(/^upi:\/\/pay\?/, '');
          const intent = `intent://pay?${q}#Intent;scheme=upi;end`;
          window.location.href = intent;
          // Another short timeout to optionally fall back
          setTimeout(() => {
            if (opts?.fallbackUrl) window.location.href = opts.fallbackUrl;
            // We still resolve — we can’t know if user cancelled or no app installed.
            resolve();
          }, 1200);
        } else {
          if (opts?.fallbackUrl) window.location.href = opts.fallbackUrl;
          resolve();
        }
      }, 1200);

      try {
        // User gesture required: call from a click handler
        window.location.href = uri;
        // We resolve immediately; actual hand-off is up to the OS/app.
        resolve();
      } catch (e) {
        clearTimeout(timer);
        reject(e instanceof Error ? e : new Error('Failed to open UPI app'));
      }
    });
  }

  get hasAnySocialLinks(): boolean {
    const s = this.social || {};
    return !!(s.website || s.instagram || s.facebook || s.twitter || s.tiktok || s.pinterest || s.linkedin || s.youtube || s.buyonline || s.amazon || s.flipkart);
  }

  get showUpi(): boolean {
    return !!(this.upi_id && this.VPA_REGEX.test(this.upi_id));
  }

  goBackToFeaturedList(): void {
    const qp = this.route.snapshot.queryParams || {};

    if (this.organizationId) {
      if (this.storeId) {
        this.router.navigate([this.slug, this.storeId]);
        return;
      }
      this.router.navigate([this.slug]);
      return;
    }

    if (qp['organizationId']) {
      this.router.navigate(['/deal/organization'], {
        queryParams: { organizationId: qp['organizationId'] }
      });
      return;
    }

    if (qp['storeId']) {
      this.router.navigate(['/deal/store'], {
        queryParams: { storeId: qp['storeId'] }
      });
      return;
    }

    this.router.navigate(['/deal']);
  }

  isYouTube(link: string): boolean {
    const u = this.toUrl(link);
    return /(?:^|\.)youtube\.com\/|youtu\.be\//i.test(u);
  }

  getYouTubeEmbed(url: string): SafeResourceUrl {
    const videoId =
      url.includes('watch?v=')
        ? url.split('watch?v=')[1].split('&')[0]
        : url.includes('youtu.be/')
          ? url.split('youtu.be/')[1].split('?')[0]
          : '';

    const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0`;

    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  // getYouTubeEmbed(link: string): SafeResourceUrl {
  //   const u = this.toUrl(link);
  //   const m1 = u.match(/youtu\.be\/([^?&]+)/i);
  //   const m2 = u.match(/[?&]v=([^?&]+)/i);
  //   const m3 = u.match(/\/shorts\/([^?&]+)/i);
  //   const id = (m1?.[1] || m2?.[1] || m3?.[1] || '').replace(/[^-\w]/g, '');
  //   // const embed = id ? `https://www.youtube.com/embed/${id}` : u;
  //   const embed = id ? `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1` : u;
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(embed);
  // }

  getVideoPoster(link: string): string {
    return 'assets/img/banner-img-1.png';
  }

  onVideoLoaded(event: Event) {
    const video = event.target as HTMLVideoElement;
    video.style.background = 'transparent';
  }

  getDirectVideoSrc(link: string): SafeResourceUrl {
    const raw = this.toUrl(link);
    const finalUrl = /^https?:\/\//i.test(raw) ? raw : this.absoluteUrl(raw);
    return this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
  }
  getVideoFileSrc(v: any): string {
    const raw = typeof v === 'string' ? v : (v?.src || '');
    return this.absoluteUrl(raw);
  }

  guessMime(v: any): string {
    const s = (typeof v === 'string' ? v : (v?.src || '')).toLowerCase();
    if (s.endsWith('.webm')) return 'video/webm';
    if (s.endsWith('.ogv') || s.endsWith('.ogg')) return 'video/ogg';
    return 'video/mp4';
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onThemeChanged(theme: Theme) {
    this.dealBackgroundColor = theme === 'light' ? 'white' : 'black';
  }

  get hasVariantGroupData(): boolean {
    return Array.isArray(this.tableRows) && this.tableRows.length > 0;
  }



  get visibleHeaders() {
    if (!this.hasVariantGroupData) return [];

    return this.headers.filter(
      (header: any) => header.id !== 'price' || this.showPriceOnOffer
    );
  }

  toggleTable() {
    this.isTableOpen = !this.isTableOpen;
  }

  toggleAttribute(attributeId: string): void {
    if (this.openedAttributeIds.has(attributeId)) {
      this.openedAttributeIds.delete(attributeId);
    } else {
      this.openedAttributeIds.add(attributeId);
    }
  }

  get variantHeaders(): VariantHeader[] {
    return this.headers.filter(h => h.id !== 'price');
  }


  // getAttributeValues(attributeId: string): { name: string; price?: number }[] {
  //   if (!Array.isArray(this.tableRows) || !Array.isArray(this.variantHeaders)) {
  //     return [];
  //   }

  //   const attrs = this.variantHeaders;
  //   const attrIndex = attrs.findIndex(h => h.id === attributeId);

  //   if (attrIndex === -1) {
  //     return [];
  //   }

  //   let filteredRows = [...this.tableRows];

  //   // Filter rows based on previously selected attributes
  //   for (let i = 0; i < attrIndex; i++) {
  //     const parentId = attrs[i].id;
  //     const selected = this.selectedAttributes[parentId];

  //     if (selected != null) {
  //       filteredRows = filteredRows.filter(
  //         row => String(row?.[parentId]) === String(selected)
  //       );
  //     }
  //   }

  //   // Build unique values map
  //   const map = new Map<string, { name: string; price?: number }>();

  //   for (const row of filteredRows) {
  //     const rawValue = row?.[attributeId];
  //     if (rawValue == null || String(rawValue).trim() === '') continue;

  //     const key = String(rawValue);

  //     // IMPORTANT FIX:
  //     // Do NOT store price as name when attribute itself is price
  //     map.set(key, {
  //       name: attributeId === 'price' ? '' : key,
  //       price: row?.price
  //     });
  //   }

  //   const result = Array.from(map.values());

  //   console.log(`getAttributeValues(${attributeId}) RESULT 👉`, result);

  //   return result;
  // }

  getAttributeValues(attributeId: string): any[] {
    if (!Array.isArray(this.tableRows)) return [];

    if (attributeId === 'price' && !this.showPriceOnOffer) {
      return [];
    }

    if (attributeId === 'price') {
      let filteredRows = [...this.tableRows];

      for (const attr of this.variantHeaders) {
        const selected = this.selectedAttributes[attr.id];
        if (selected) {
          filteredRows = filteredRows.filter(
            row => String(row?.[attr.id]) === String(selected)
          );
        }
      }

      return Array.from(
        new Map(
          filteredRows
            .filter(r => r.price !== null && r.price !== undefined)
            .map(r => [r.price, { price: r.price }])
        ).values()
      );
    }

    const attrs = this.variantHeaders;
    const attrIndex = attrs.findIndex(h => h.id === attributeId);

    let filteredRows = [...this.tableRows];

    for (let i = 0; i < attrIndex; i++) {
      const parentId = attrs[i].id;
      const selected = this.selectedAttributes[parentId];

      if (selected) {
        filteredRows = filteredRows.filter(
          row => String(row?.[parentId]) === String(selected)
        );
      }
    }

    return Array.from(
      new Set(
        filteredRows
          .map(row => row?.[attributeId])
          .filter(v => v !== null && v !== undefined)
      )
    ).map(v => ({ name: v }));
  }


  // getAttributeValues(attributeId: string): string[] {
  //   if (!Array.isArray(this.tableRows)) return [];

  //   const selectedValueForThisHeader = this.selectedAttributes?.[attributeId];

  //   if (attributeId === 'price') {
  //     let filteredRows = [...this.tableRows];

  //     for (const attr of this.variantHeaders) {
  //       const selected = this.selectedAttributes[attr.id];
  //       if (selected) {
  //         filteredRows = filteredRows.filter(
  //           row => String(row?.[attr.id]) === selected
  //         );
  //       }
  //     }

  //     const values = Array.from(
  //       new Set(
  //         filteredRows
  //           .map(row => String(row?.price ?? ''))
  //           .filter(v => v.trim().length > 0)
  //       )
  //     );

  //     if (selectedValueForThisHeader) {
  //       return values.includes(selectedValueForThisHeader)
  //         ? [selectedValueForThisHeader]
  //         : [];
  //     }

  //     return values;
  //   }


  //   const attrs = this.variantHeaders;
  //   const attrIndex = attrs.findIndex(h => h.id === attributeId);

  //   let filteredRows = [...this.tableRows];

  //   for (let i = 0; i < attrIndex; i++) {
  //     const parentId = attrs[i].id;
  //     const selected = this.selectedAttributes[parentId];

  //     if (selected) {
  //       filteredRows = filteredRows.filter(
  //         row => String(row?.[parentId]) === selected
  //       );
  //     }
  //   }

  //   const values = Array.from(
  //     new Set(
  //       filteredRows
  //         .map(row => String(row?.[attributeId] ?? ''))
  //         .filter(v => v.trim().length > 0)
  //     )
  //   );

  //   if (selectedValueForThisHeader) {
  //     return values.includes(selectedValueForThisHeader)
  //       ? [selectedValueForThisHeader]
  //       : [];
  //   }

  //   return values;
  // }



  // onVariantValueClick(attributeId: string, value: string) {

  //   if (attributeId !== 'price') {
  //     const attrs = this.variantHeaders;
  //     const attrIndex = attrs.findIndex(h => h.id === attributeId);

  //     for (let i = attrIndex + 1; i < attrs.length; i++) {
  //       delete this.selectedAttributes[attrs[i].id];
  //     }

  //     if (attributeId !== 'price') {
  //       delete this.selectedAttributes['price'];
  //     }
  //   }

  //   this.selectedAttributes = {
  //     ...this.selectedAttributes,
  //     [attributeId]: value
  //   };
  //   this.openedAttributeIds.delete(attributeId);
  // }


  onVariantValueClick(attributeId: string, value: any) {

    const selectedValue =
      attributeId === 'price' ? value.price : value.name;

    if (attributeId !== 'price') {
      const attrs = this.variantHeaders;
      const attrIndex = attrs.findIndex(h => h.id === attributeId);

      for (let i = attrIndex + 1; i < attrs.length; i++) {
        delete this.selectedAttributes[attrs[i].id];
      }

      delete this.selectedAttributes['price'];
    }

    this.selectedAttributes = {
      ...this.selectedAttributes,
      [attributeId]: selectedValue
    };

    this.openedAttributeIds.delete(attributeId);
  }


  trackByValue(index: number, value: any): any {
    return value?.price ?? value?.name ?? index;
  }


  openAllVariants() {
    this.showAllVariants = true;
  }


  getSortedBuyOn(buyOnList: any[]) {
    if (!buyOnList) return [];
    return [...buyOnList].sort((a, b) => {
      const aPriority = a.buyOnName?.toLowerCase() === 'shopify' ? 0 : 1;
      const bPriority = b.buyOnName?.toLowerCase() === 'shopify' ? 0 : 1;
      return aPriority - bPriority;
    });
  }

  hasPriceValues(): boolean {
    return (
      this.showPriceOnOffer &&
      Array.isArray(this.tableRows) &&
      this.tableRows.some(r => r?.price !== null && r?.price !== undefined)
    );
  }

  togglePriceVisibility(isVisible: boolean) {
    this.showPriceOnOffer = isVisible;

    if (!this.showPriceOnOffer) {
      delete this.selectedAttributes['price'];
      this.openedAttributeIds.delete('price');
    }
  }


}